// This file was autogenerated by "./bin/generateGetFirstDayOfWeek.js" script.

import getTerritoryFromLocale from './getTerritoryFromLocale'
import getLanguageFromLocale from './getLanguageFromLocale'

const territoriesByFirstDayOfWeek = [
  [
    "AG",
    "AS",
    "BD",
    "BR",
    "BS",
    "BT",
    "BW",
    "BZ",
    "CA",
    "CO",
    "DM",
    "DO",
    "ET",
    "GT",
    "GU",
    "HK",
    "HN",
    "ID",
    "IL",
    "IN",
    "JM",
    "JP",
    "KE",
    "KH",
    "KR",
    "LA",
    "MH",
    "MM",
    "MO",
    "MT",
    "MX",
    "MZ",
    "NI",
    "NP",
    "PA",
    "PE",
    "PH",
    "PK",
    "PR",
    "PT",
    "PY",
    "SA",
    "SG",
    "SV",
    "TH",
    "TT",
    "TW",
    "UM",
    "US",
    "VE",
    "VI",
    "WS",
    "YE",
    "ZA",
    "ZW"
  ],
  [
    "AD",
    "AI",
    "AL",
    "AM",
    "AN",
    "AR",
    "AT",
    "AU",
    "AX",
    "AZ",
    "BA",
    "BE",
    "BG",
    "BM",
    "BN",
    "BY",
    "CH",
    "CL",
    "CM",
    "CN",
    "CR",
    "CY",
    "CZ",
    "DE",
    "DK",
    "EC",
    "EE",
    "ES",
    "FI",
    "FJ",
    "FO",
    "FR",
    "GB",
    "GE",
    "GF",
    "GP",
    "GR",
    "HR",
    "HU",
    "IE",
    "IS",
    "IT",
    "KG",
    "KZ",
    "LB",
    "LI",
    "LK",
    "LT",
    "LU",
    "LV",
    "MC",
    "MD",
    "ME",
    "MK",
    "MN",
    "MQ",
    "MY",
    "NL",
    "NO",
    "NZ",
    "PL",
    "RE",
    "RO",
    "RS",
    "RU",
    "SE",
    "SI",
    "SK",
    "SM",
    "TJ",
    "TM",
    "TR",
    "UA",
    "UY",
    "UZ",
    "VA",
    "VN",
    "XK"
  ],
  [],
  [],
  [],
  [
    "MV"
  ],
  [
    "AE",
    "AF",
    "BH",
    "DJ",
    "DZ",
    "EG",
    "IQ",
    "IR",
    "JO",
    "KW",
    "LY",
    "OM",
    "QA",
    "SD",
    "SY"
  ]
]
const languagesByFirstDayOfWeek = [
  [
    "aa",
    "af",
    "am",
    "as",
    "bn",
    "ch",
    "cr",
    "dz",
    "en",
    "gn",
    "gu",
    "he",
    "hi",
    "id",
    "ik",
    "in",
    "iu",
    "iw",
    "ja",
    "jv",
    "jw",
    "ki",
    "km",
    "kn",
    "ko",
    "ks",
    "lo",
    "mh",
    "ml",
    "mr",
    "mt",
    "my",
    "nd",
    "ne",
    "nr",
    "nv",
    "oj",
    "om",
    "or",
    "pa",
    "pi",
    "pt",
    "qu",
    "sa",
    "sd",
    "sm",
    "sn",
    "ss",
    "st",
    "su",
    "ta",
    "te",
    "th",
    "ti",
    "tl",
    "tn",
    "ts",
    "ur",
    "ve",
    "xh",
    "zu"
  ],
  [
    "ab",
    "an",
    "av",
    "az",
    "ba",
    "be",
    "bg",
    "bo",
    "br",
    "bs",
    "ca",
    "ce",
    "co",
    "cs",
    "cu",
    "cv",
    "cy",
    "da",
    "de",
    "el",
    "es",
    "et",
    "eu",
    "fi",
    "fj",
    "fo",
    "fr",
    "fy",
    "ga",
    "gd",
    "gl",
    "hr",
    "hu",
    "hy",
    "ie",
    "ii",
    "is",
    "it",
    "ji",
    "ka",
    "kk",
    "ku",
    "kv",
    "kw",
    "ky",
    "la",
    "lb",
    "li",
    "lt",
    "lv",
    "mi",
    "mk",
    "mn",
    "mo",
    "ms",
    "nb",
    "nl",
    "nn",
    "no",
    "oc",
    "os",
    "pl",
    "rm",
    "ro",
    "ru",
    "sc",
    "se",
    "si",
    "sk",
    "sl",
    "sq",
    "sr",
    "sv",
    "tg",
    "tk",
    "tr",
    "tt",
    "ug",
    "uk",
    "uz",
    "vi",
    "wa",
    "yi",
    "za",
    "zh"
  ],
  [],
  [],
  [],
  [
    "dv"
  ],
  [
    "ae",
    "ar",
    "fa",
    "ps"
  ]
]

// Returns the "first day of week".
// 0 means "Sunday", 1 means "Monday", etc.
// Is 0 by default, as defined in the "US" country.
//
// https://date-fns.org/v2.28.0/docs/startOfWeek
// https://github.com/tc39/ecma402/issues/6
// https://stackoverflow.com/questions/34469869/how-do-i-find-out-which-is-the-first-day-of-the-week-in-the-current-locale?noredirect=1&lq=1
// https://github.com/unicode-org/cldr/blob/7a2fada9220bfddef3936bdffaff173041aef8da/common/supplemental/supplementalData.xml#L4696
//
// https://en.wikipedia.org/wiki/Week
//
// "While, for example, the United States, Canada, Brazil, Japan and other countries
//  consider Sunday as the first day of the week, and while the week begins with Saturday
//  in much of the Middle East, the international ISO 8601 standard[a] and most of Europe
//  has Monday as the first day of the week.[2] The Geneva-based ISO standards organization
//  uses Monday as the first day of the week in its ISO week date system."
//
export default function getFirstDayOfWeek(locale) {
	const territory = getTerritoryFromLocale(locale)
	if (territory) {
		let i = 0
		while (i < territoriesByFirstDayOfWeek.length) {
			if (territoriesByFirstDayOfWeek[i].indexOf(territory) >= 0) {
				return i
			}
			i++
		}
	}
	const language = getLanguageFromLocale(locale)
	let i = 0
	while (i < languagesByFirstDayOfWeek.length) {
		if (languagesByFirstDayOfWeek[i].indexOf(language) >= 0) {
			return i
		}
		i++
	}
}